import React, { useState } from "react";
import PropTypes from "prop-types";
import { Radio } from "antd";
import Collapse, { Panel } from "../../../../common/component/Collapse";
import {
  FormWrapperInputComponent,
  HeaderComponent
} from "../../../../common/component/Index";
import Wrapper from "../../../../common/component/Wrapper";
import {
  DETAIL_ACTIONS,
  CAMPAIGN as CAMPAIGN_ENUM
} from "../../../../../../constants/Define";
import { useTranslation } from "react-i18next";
import Input from "../../../../common/component/Input";

const defaultCollapseKey = "loyaltyCodeSection";

function LoyaltyCodeSection(props) {
  const { campaign, action, onChange } = props;

  const { t } = useTranslation();
  const [collapseKey, setCollapseKey] = useState();

  const onToggleCollapse = () => {
    if (collapseKey) {
      setCollapseKey();
    } else {
      setCollapseKey(defaultCollapseKey);
    }
  };

  const changeCodeType = isLoyalty => {
    // isLoyalty type boolean
    if (!isLoyalty) {
      // onChange('codeType', CAMPAIGN_ENUM.CODE_TYPE.STANDARD.value)
    } else {
      onChange("codeType", CAMPAIGN_ENUM.CODE_TYPE.CUSTOMIZE.value);
    }
  };

  const onChangeTypeCampaign = value => {
    changeCodeType(value);
    onChange("isLoyaltyVoucher", value);
  };

  return (
    <Collapse
      activeKey={collapseKey}
      bordered={false}
      defaultActiveKey={defaultCollapseKey}
      style={{ width: "100%", background: "inherit" }}
      expandIconPosition={"right"}
      onChange={onToggleCollapse}
    >
      <Panel
        key={defaultCollapseKey}
        header={
          <HeaderComponent
            title={t("item.campaign.loyaltyCode")}
            className="col-md-12"
            style={{
              userSelect: "none",
              paddingTop: "unset",
              paddingBottom: "unset"
            }}
          />
        }
      >
        <Wrapper className={"row campaign-collapse-row"}>
          <Wrapper className="col-md-12">
            <FormWrapperInputComponent
              visible={action !== DETAIL_ACTIONS.TRANSLATE}
            >
              <Radio.Group
                value={campaign.isLoyaltyVoucher}
                // onChange={ e => onChange('isLoyaltyVoucher', e.target.value) }
                onChange={e => onChangeTypeCampaign(e.target.value)}
                visible={action !== DETAIL_ACTIONS.TRANSLATE}
              >
                <Radio
                  value={false}
                  className="mr-0"
                  style={{
                    display: "block"
                  }}
                >
                  {t("item.campaign.optionNo")}
                </Radio>
                <Radio
                  value={true}
                  className="mr-0"
                  style={{
                    display: "block"
                  }}
                >
                  {t("item.campaign.optionYes")}
                </Radio>
              </Radio.Group>
            </FormWrapperInputComponent>
          </Wrapper>
        </Wrapper>
      </Panel>
    </Collapse>
  );
}

LoyaltyCodeSection.propTypes = {
  campaign: PropTypes.object,
  action: PropTypes.string,
  onChange: PropTypes.func
};

LoyaltyCodeSection.defaultProps = {
  campaign: {},
  action: "",
  onChange: () => {}
};

export default LoyaltyCodeSection;
